module.exports = __webpack_public_path__ + "static/media/aauxnext-bdit.58f937dc.woff2";